<div class="bg-ultralightGray">
  <div class="h-screen m-auto max-h-full flex flex-col">
    <app-navbar [isMobile]="isMobile"></app-navbar>
    <div class="flex-1 overflow-auto">
      @if (!siteKillSwitch) {
        <router-outlet></router-outlet>
      } @else {
        <app-kill-switch></app-kill-switch>
      }
    </div>
  </div>
</div>
